// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"98fffbda","453":"5712a731"}[chunkId] + ".chunk.js";
};